// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({sx, ...other}) {
  const { user } = useAuth();
  const avatar = createAvatar(user?.name);
  return (
    <Avatar
      src={user?.photoUrl}
      alt={user?.name}
      color={user?.photoUrl ? 'default' : avatar.color}
      sx={user?.photoUrl ? sx : {color: 'primary.dark', backgroundColor: 'primary.lighter', ...sx}}
      {...other}
    >
      {avatar.name}
    </Avatar>
  );
}
